import rulesConstants from "@/assets/constants/rules.constants";
import { doc, getDoc } from "firebase/firestore";
import Vue from "vue";
import { auth, colUsers, platforms } from "./firebase.utils";
import { useGtm } from "@gtm-support/vue2-gtm";

const moment = require("moment");
export const getDate = (date = new Date()) => {
  return moment(date).format("YYYY-MM-DDTHH:mm:ss");
};

export const formatDate = (date) => {
  return moment(date).format("DD MMM YY h:mm A");
};

export const formatDateDDMMYYYY = (date = new Date()) => {
  if(date.seconds) {
    return moment(date.seconds * 1000).format("DD MMM YYYY");
  }
  return moment(date).format("DD MMM YYYY");
};

export const connectedHandle = async (platform, wid,uid) => {

  if(!uid){
    uid = auth?.currentUser?.uid
  }
  const userDocRef = doc(colUsers, uid , "fly_workspaces", wid);
  // Fetch data from connected-apps-token
  let data = (
    await getDoc(doc(userDocRef, "connected-apps-token", platform))
  ).data();
  let expiryDate = null;
  let autoRefreshToken = null;
  const platformRef = doc(platforms, platform);
  const fly_platform = (await getDoc(platformRef)).data();

  if (fly_platform && fly_platform.auto_refresh_token !== undefined) {
    autoRefreshToken = fly_platform.auto_refresh_token;
  }
  if (data && platform !== "google_business_profile") {
    if (data.expires_at) {
      if (typeof data.expires_at === "string") {
        return null;
      } else {
        let expires_at = data.expires_at.toDate();
        expiryDate = moment(expires_at).format("LL");
        if (autoRefreshToken === true) {
          return null;
        } else return expiryDate;
      }
    }
  }
  return expiryDate; // Don't show otherwise
};

export function getRules(rules) {
  if (!rules) return [];
  rules = rules.split("|");
  let list = [];
  rules.forEach((rule) => {
    if (rulesConstants[rule]) list.push(rulesConstants[rule]);
  });
  return list;
}

export const mapDocs = (docs) => {
  return docs.map((i) => {
    return { ...i.data(), id: i.id };
  });
};
export const mapFacets = (item) => {
  return Object.keys(item).map((facet) => {
    let value = item[facet];
    let name = facet;
    if (!name.startsWith("#")) name = `#${name}`;
    return { name, value, facet };
  });
};
export const formatFileSize = (sizeInBytes) => {
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (sizeInBytes === 0) return "0 Byte";
  const i = parseInt(Math.floor(Math.log(sizeInBytes) / Math.log(1024)));
  const roundedSize = (sizeInBytes / Math.pow(1024, i)).toFixed(2);
  // return Math.round(sizeInBytes / Math.pow(1024, i), 2) + " " + sizes[i];
  return `${roundedSize} ${sizes[i]}`;
};
export const mapFacetSelect = (item) => {
  return Object.keys(item).map((name) => {
    let formatedName = name?.charAt(0).toUpperCase() + name?.slice(1);
    return { name: `${formatedName} (${item[name]})`, value: name };
  });
};

export function getBase64(file) {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      resolve(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
      reject(error);
    };
  });
}

export const GMB_ERROR_MESSAGES = {
  ERROR_CODE_UNSPECIFIED                 : "Something went wrong, but we couldn't identify the specific issue. Please try again later.",
  ASSOCIATE_OPERATION_ON_VERIFIED_LOCATION: "This location is already verified, so changes to its association aren’t allowed.",
  ASSOCIATE_LOCATION_INVALID_PLACE_ID    : "The selected place ID is not valid. Please check the location details.",
  INVALID_PHONE_NUMBER                   : "The phone number entered is not valid. Please check the number format and try again.",
  INVALID_PHONE_NUMBER_FOR_REGION        : "The phone number isn’t valid for the selected country or region.",
  INVALID_CATEGORY                       : "The business category you selected is not valid. Please choose another category.",
  CATEGORY_NOT_ALLOWED                   : "This business category is not allowed for your location or business type.",
  INVALID_STORE_CODE                     : "The store code you entered is invalid. Please use a valid alphanumeric code.",
  STORE_CODE_ALREADY_EXISTS              : "This store code is already in use. Please use a unique code for each location.",
  INVALID_LANGUAGE_CODE                  : "The language selected is not supported. Please choose a valid language.",
  INVALID_COUNTRY_CODE                   : "The country code provided is incorrect. Please select a valid country.",
  INVALID_REGION_CODE                    : "The region or state selected is not recognized. Please review your selection.",
  INVALID_ATTRIBUTE_VALUE                : "One of the values you entered is not accepted. Please correct it.",
  ATTRIBUTE_NOT_SET                      : "A required detail is missing. Please fill out all necessary fields.",
  INVALID_REQUEST                        : "Something went wrong with your update request. Please try again.",
  NOT_AUTHORIZED                         : "You are not authorized to make this change. Please check your access rights.",
  PERMISSION_DENIED                      : "You don’t have permission to perform this action.",
  RESOURCE_NOT_FOUND                     : "We couldn’t find the location you’re trying to update. Please check the details.",
  RESOURCE_ALREADY_EXISTS                : "This item already exists. Please avoid adding duplicates.",
  INTERNAL_ERROR                         : "Something went wrong on our end. Please try again later.",
  SERVICE_UNAVAILABLE                    : "The service is temporarily unavailable. Please try again shortly.",
  UNSUPPORTED_OPERATION                  : "This type of change is not supported by the platform.",
  QUOTA_EXCEEDED                         : "You’ve reached your daily limit for changes. Try again tomorrow.",
  RATE_LIMIT_EXCEEDED                    : "You’re making too many updates too quickly. Please slow down and try again.",
  INVALID_ARGUMENT                       : "One or more fields have incorrect data. Please check and fix them.",
  FAILED_PRECONDITION                    : "This change can't be made right now due to current settings or status.",
  ABORTED                                : "The update was cancelled due to a temporary issue. Please try again.",
  OUT_OF_RANGE                           : "A value you entered is too high or too low. Please adjust it.",
  UNIMPLEMENTED                          : "This feature isn't supported yet.",
  INTERNAL                               : "We ran into an unexpected issue. Please try again later.",
  UNAVAILABLE                            : "Some services are currently unavailable. Try again soon.",
  DATA_LOSS                              : "There was a data issue during your update. Please contact support.",
  UNAUTHENTICATED                        : "You need to log in or reauthenticate to continue.",
  THROTTLED                              : "You’ve updated this field too frequently. Please wait before trying again.",
  CANNOT_MODIFY_VERIFIED_LOCATION        : "This location is verified and can’t be modified through this method.",
  CONFLICTING_LOCATION_STATE             : "This location’s current state doesn’t allow this change. Try again later or resolve existing issues."
};

export function trackGTM(event, category, action, label, value) {
  const gtm = useGtm();
  gtm.trackEvent({
    event: event,
    category: category,
    action: action,
    label: label,
    value: value,
    noninteraction: false,
  });
  console.log("GTM Trigger : ", event);
}
export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
export function uniqueArray(array) {
  console.log("De duplicating array");
  return [...new Set(array)];
}

export const eventBus = new Vue();
